module.exports = __webpack_public_path__ + "img/message-exclamation.aac94219.svg";